<template>
  <div class="chapter-content">
    <div
      class="period-header clearfix"
      :class="{ 'period-header-7': courseType == 7 }"
    >
      <div
        class="period-title-wrapper"
        :class="{
          disabled: !$services.CourseService.checkLiveState(courseType, period),
        }"
        @click="targetPeriod(period)"
      >
        <span class="period-point"></span>
        <CoursePeriodsType :periods_type="courseType"></CoursePeriodsType>
        <span class="period-try" v-if="period.is_try_see">试看</span>
        <span
          class="period-title"
          :style="{
            cursor:
              courseType == 5 || courseType == 8 || courseType == 10
                ? 'pointer'
                : 'default',
          }"
          :title="period.periods_title"
        >
          {{ period.periods_title }}
        </span>
        <span class="progress-wrap" v-if="(courseType == 5 || courseType == 8) && is_Live!='直播' ">
          <ProgressBar
            v-if="period.progress_rate < 100"
            class="progress"
            :value="period.progress_rate"
            type="pie"
            backColor="white"
            foreColor="#bb1c20"
            style="width: 16px; border: 1px solid #bb1c20; border-radius: 50%"
          ></ProgressBar>
          <i v-else class="el-icon-success"></i>
          <span>{{ period.progress_rate }}%</span>
        </span>
      </div>
      <div class="period-info" v-if="courseType != 10">
        <div v-if="period.start_play">
          {{ period.start_play + " - " + period.end_play }}
        </div>
        <div v-if="courseType != 5 && courseType != 8" class="period-teacher">
          {{ period.teacher_name }}
        </div>
        <div class="period-state">
          <template
            v-if="courseType == 2 || courseType == 3 || courseType == 15"
          >
            <span
              :class="{
                // disabled: period.play_type == 3 || period.play_type == 5,
                'not-begin': period.play_type == 1,
                living: period.play_type == 2,
              }"
              class="operate small"
              @click.stop="targetPeriod(period, 1)"
            >
              <template v-if="period.play_type == 1">未开始</template>
              <template v-else-if="period.play_type == 2">
                <img
                  class="img-living"
                  src="@/assets/images/course/period-progress@2x.png"
                />
                直播中
              </template>
              <template
                v-else-if="period.play_type == 3 || period.play_type == 5"
              >
                查看回放
              </template>
              <template v-else-if="period.play_type == 4">查看回放</template>
            </span>
          </template>
          <template v-else-if="courseType == 7">
            <span v-if="period.play_type == 1">未开始</span>
            <span v-else-if="period.play_type == 2">上课中</span>
            <span v-else-if="period.play_type == 3">已结束</span>
          </template>
          <span
            class="progress-wrap"
            v-if="courseType != 7 && courseType != 5 && courseType != 8&&is_Live!='直播'"
          >
            <ProgressBar
              v-if="period.progress_rate < 100"
              class="progress"
              :value="period.progress_rate"
              type="pie"
              backColor="white"
              foreColor="#bb1c20"
              style="width: 16px; border: 1px solid #bb1c20; border-radius: 50%"
            ></ProgressBar>
            <i v-else class="el-icon-success"></i>
            <span>{{ period.progress_rate }}%</span>
          </span>
        </div>
      </div>
    </div>
    <FileList
      v-if="period.datum_download==1"
      :period="period"
      :showDownload="showDownload"
      :fileList="getFile(period.datum)"
    />
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip
      v-if="showSoldOut"
      :show.sync="showSoldOut"
    ></CourseSoldOutTip>
  </div>
</template>
<script>
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import FileList from "@/modules/stu/components/FileList";
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";

import { CoursePeriodsType as CoursePeriodsTypeFun } from "@/utils/enums";


export default {
  name: "MemberStudyPeriod",
  components: {
    CourseSoldOutTip,
    ProgressBar,
    FileList,
    CoursePeriodsType,
    CourseContentTip,
  },
  props: {
    period: {
      type: Object,
    },
    course_type: {
      type: Number,
    },
    course_id: {
      type: Number,
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showContentDialog: false,
      chapter_content: "",
      showSoldOut: false,

    };
  },
  created() {

      
        const isLive =(start,end)=>{//  1未开播  2直播中  3直播结束
          if(start==0){return 1}//未开播
          if(start!=0 && end==''){return 2}//直播中
          if(start!=0 && end!=''){return 3}//直播结束
        }

        this.period.play_type = isLive(this.period.start_op_time,this.period.end_op_time)

  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    courseType() {
      return this.period.periods_type;
    },
    is_Live(){
      return CoursePeriodsTypeFun.getValue(this.period.periods_type)
    }
  },
  methods: {
    //处理课时课件文件
    getFile(data) {
      if (data && data.length > 0) {
        return data.map(item => ({
          ...item,
          ware_filename: item.file_name,
        }));
      }
      return [];
    },
    check() {
      if (this.course.status == 2 && this.course.is_go_to_study == 0) {
        this.showSoldOut = true;
        return false;
      }
      return true;
    },
    async visitFile(id, index) {
      if (!this.check()) {
        return;
      }
      await this.$services.CourseService.openPeriodFile(this.period, id, index);
    },
    async targetPeriod(period, type) {
      period.play_type =  period.play_type ==3 ? 4 : period.play_type

      if (!this.check()) {
        return;
      }
      /*
      if (this.period.bjy_encode_status != 1) {
        this.$info("视频转码中，请稍后观看");
        return;
      }
      */
      if (
        !this.$services.CourseService.checkLiveState(
          this.courseType,
          period,
          type,
        )
      ) {
        return;
      }
      if (this.course.valid_status != 1) {
        this.$info("该课程已过期，无法继续学习");
        return;
      }
      // 混合课面授课弹出课时内容\
      if (this.period.periods_type == 7 && this.period.content) {
        this.chapter_content = this.period.content;
        this.showContentDialog = true;
        return;
      }
      await this.$services.CourseService.checkLimit(this.course_id);
      if (this.courseType == 10) {
        let data = await this.$services.CourseService.getPeriodContent(period);
        this.chapter_content = data.course_content;
        this.showContentDialog = true;
      } else {
        if (this.courseType == 16) {
          if (!type) {
            type = 2;
          }
        } else if (!type) {
          type = 1;
        }
        await this.$services.CourseService.watchVideo(
          period,
          this.courseType,
          this.course_id,
          type,
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.chapter-content {
  display: none;
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  .period-header {
    position: relative;
  }
  .period-title-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    &:hover {
      color: $primary-color;
    }
    &.disabled {
      cursor: default;
    }
  }
  .period-title {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .period-try {
    background: #fede55;
    border-radius: 14px;
    color: #433c39;
    font-size: 12px;
    height: 22px;
    line-height: 22px;
    padding: 0 10px;
    margin-right: 5px;
  }
  .period-point {
    width: 5px;
    height: 5px;
    background-color: $primary-color;
    border-radius: 100%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 18px;
  }
  .period-course-type {
    height: 22px;
    background: #ffffff;
    border: 1px solid $primary-color;
    border-radius: 12px;
    line-height: 20px;
    font-size: 12px;
    color: $primary-color;
    padding: 0 5px;
    box-sizing: border-box;
    margin-right: 8px;
  }
  .period-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    margin: 3px 0 0 0;
  }
  .period-file a {
    font-size: 14px;
    color: rgba(89, 89, 89, 1);
    &:hover {
      color: $primary-color;
    }
  }
  .chapter-expand .chapter-content {
    display: block;
  }
  .period-file {
    padding-left: 15px;
    margin-top: 8px;
  }
  .file-type {
    margin-right: 5px;
  }
  .period-teacher {
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 10px;
    padding-left: 10px;
    position: relative;
    flex-grow: 1;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      width: 1px;
      height: 16px;
      background: #cccccc;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .period-state {
    color: #cccccc;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .operate {
    display: inline-block;
    height: 32px;
    color: $primary-color;
    line-height: 30px;
    border-radius: 16px;
    border: 1px solid rgba($primary-color, 0.5);
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;

    &:hover:not(.disabled) {
      background-color: $primary-color-08;
    }

    &.small {
      width: 90px;
    }

    &.big {
      width: 132px;

      &:first-child {
        margin-right: 10px;
      }
    }
    &.disabled,
    &.not-begin {
      color: #cccccc;
    }

    &.not-begin {
      border: none;
    }

    &.disabled {
      border: 1px solid rgba(204, 204, 204, 0.5);
      cursor: default;
    }

    &.living {
      border: none;
      .img-living {
        width: 14px;
        margin-right: 10px;
      }
    }
  }
  .progress-wrap {
    width: 64px;
    display: inline-block;
    overflow: hidden;
    margin-left: 16px;
    flex-shrink: 0;
    .progress {
      margin-right: 8px;
      vertical-align: text-bottom;
      margin-top: 1px;
    }
    > svg,
    > span {
      float: left;
    }
    .el-icon-success {
      color: $primary-color;
      margin-right: 8px;
      float: left;
      margin-top: 0px;
      font-size: 18px;
    }
  }
}
</style>
